export default {
  breadcrumb: {
    id: 'breadcrumb_aria_label',
    defaultMessage: 'Breadcrumb',
  },
  loadMore: {
    id: 'review_display_loadmore_reviews',
    defaultMessage: 'Show more reviews',
  },
  seoLinksTitle: {
    id: 'popular_search_title',
    defaultMessage: 'Popular searches',
  },
  titleAllProducts: {
    id: 'reviews_page_all_products_title',
    defaultMessage: 'Customer reviews for all refurbished products',
  },
  titleBattery: {
    id: 'reviews_page_battery_title',
    defaultMessage:
      'Customer reviews about batteries for all refurbished phones',
  },
  breadcrumbHomePage: {
    id: 'reviews_page_breadcrumb_home',
    defaultMessage: 'Home',
  },
  breadcrumbPageAllProducts: {
    id: 'reviews_page_breadcrumb_current_page',
    defaultMessage: 'Reviews',
  },
  breadcrumbPageBattery: {
    id: 'reviews_page_breadcrumb_current_page_battery',
    defaultMessage: 'Reviews about batteries for refurbished phones',
  },
  SEOTitleAllProducts: {
    id: 'review_display_all_reviews_meta_title',
    defaultMessage:
      'Is Back Market reputable? Read reviews for all our refurbished electronics',
  },
  SEOTitleBattery: {
    id: 'review_display_battery_reviews_meta_title',
    defaultMessage:
      'Is Back Market reputable? Read reviews about batteries for all our refurbished phones',
  },
  SEODescriptionAllProducts: {
    id: 'review_display_all_reviews_meta_description_new',
    defaultMessage:
      'Wondering if Back Market services are reliable? Are prices a scam? Overall rating is {rate} out of {count} reviews. Read all of our customer reviews.',
  },
  SEODescriptionBattery: {
    id: 'review_display_battery_reviews_meta_description',
    defaultMessage: 'Battery reviews for all our refurbished phones',
  },
} as const
